import styled, { css } from 'styled-components';

import {
    CAUTION_BASE,
    CONTENT_BASE,
    CONTENT_DISABLED,
    PRIMARY_BASE,
} from '@amzn/ring-common-style-library/lib/colors';

import { 
    HEADING_SMALL_MEDIUM,
} from '@amzn/ring-common-style-library/lib/typography';

const indicatorColors = {
    AGENT: css`
        fill: ${PRIMARY_BASE};
    `,
    CUSTOM_BOT: css`
        fill: ${PRIMARY_BASE};
    `,
    CUSTOMER: css`
        fill: ${PRIMARY_BASE};
    `,
    SUPERVISOR: css`
        fill: ${PRIMARY_BASE};
    `,
    SYSTEM: css`
        fill: ${PRIMARY_BASE};
    `,
    DISCONNECTED: css`
        fill: ${CONTENT_DISABLED};
    `,
    IDLE: css`
        fill: ${CAUTION_BASE};
    `,
};
const EventWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    flex-direction: column;
`;

const EventIcon = styled.div<{
    indicator: 'AGENT' | 'CUSTOMER' | 'CUSTOM_BOT' | 'SUPERVISOR' | 'SYSTEM' | 'DISCONNECTED' | 'IDLE';
}>`
    height: 30px;
    width: 30px;
    margin-right: auto;
    padding: -2px;

    border-radius: 50px;
    ${({ indicator }) => indicatorColors[indicator]};

`;

const EventText = styled.div`
    ${HEADING_SMALL_MEDIUM};
    color: ${CONTENT_BASE};
    text-align: left;
`;

export default {
    EventIcon,
    EventText,
    EventWrapper,
};
